import React, { useState } from 'react';
import { Collapse, Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import MinusIcon from 'mdi-react/MinusIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faEdit, faArrowDown, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import AlertModal from '../../../../shared/components/Modal';
import { useHistory } from "react-router-dom";

import ListActivities from './ListActivities';
import ListActivitiesActions from './ListActivitiesActions';

const MedicalCollapseComponent = ({ feasibility, visit, className, title, children, number_visit, cost, sponsor, diff, activities, editVisitAction, actividades }) => {

  const history = useHistory();

  const [collapse, setCollapse] = useState(false);
  const [view, setView] = useState({ styleClass: 'closed', icon: <PlusIcon /> });
  const [numberVisit, setNumberVisit] = React.useState(number_visit);
  const [costVisit, setCostVisit] = React.useState(cost);
  const [sponsorVisit, setSponsorVisit] = React.useState(sponsor);
  const [diffVisit, setDiffVisit] = React.useState(diff);
  const [listActivities, setListActivities] = React.useState([]);

  //Alerta
  const [showAlertModal, setAlerShowModal] = React.useState(false);
  const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
  const [colorAlertModal, setAlertColorModal] = React.useState("success");

  const [deleteVisit, setDeleteVisit] = React.useState(false);

  const alertModal = (success, message) => {
    if (success == true) {
      setAlertColorModal("success");
    }
    else {
      setAlertColorModal("danger");
    }
    setAlerShowModal(true);
    setAlertMessageModal(message);
  }

  const onEntering = () => {
    setView({ styleClass: 'opening', icon: <MinusIcon /> });
  };

  const onEntered = () => {
    setView({ styleClass: 'opened', icon: <MinusIcon /> });
  };

  const onExiting = () => {
    setView({ styleClass: 'closing', icon: <PlusIcon /> });
  };

  const onExited = () => {
    setView({ styleClass: 'closed', icon: <PlusIcon /> });
  };

  const toggle = () => {
    setCollapse(prevState => !prevState);
  };

  const editVisit = (e) => {
    setCollapse(prevState => !prevState);
    editVisitAction(visit);
  }

  const deleteVisitAction = (e) => {

    console.log(visit);
    if (parseInt(visit.estado) != 1) {
      setCollapse(prevState => !prevState);
      alertModal(false, "No puede eliminar una visita que ya fue agendada");
    }
    else {
      setCollapse(prevState => !prevState);
      setDeleteVisit(true);
      confirmDeleteAlert();
    }
  }

  const confirmDeleteAlert = () => {
    setAlertColorModal("warning");
    setAlertMessageModal("Esta seguro que eliminara esta visita?? Esto puede afectar el proceso del Presupuesto");
    setAlerShowModal(true);
  }

  const okModal = () => {
    setDeleteVisit(false);
    switch (colorAlertModal) {
      case "warning":
        if (deleteVisit == true) {
          submitDelete();
        }
        break;

      case "success":
        let _url = "/clinical-studio/budget";
        if (window.location.pathname === process.env.PUBLIC_URL + '/clinical-studio/budget') {
          history.replace(process.env.PUBLIC_URL+"/");
          setTimeout(() => {
            history.replace({
              pathname: process.env.PUBLIC_URL +_url,
              state: feasibility
            });
          }, 0);
        } else {
          history.push({
            pathname: process.env.PUBLIC_URL +_url,
            state: feasibility
          });
        }
        break;
      default:
        setAlerShowModal(false);
        break;
    }
  }

  const submitDelete = async () => {
    await fetch(`${process.env.REACT_APP_PUBLIC_URL}visitas/delete`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify({
        id_visita: visit.id_visita
      })
    }).then(response => response.json()).then(data => {
      console.log(data);
      alertModal(true, "Visita Eliminada correctamente");
    }).catch(err => {
      console.log(err);
      alertModal(false, "Ha ocurrido un error en el servidor");
    });
  }

  const AllActivities = () => {
    return (
      <Row>
        <Col >
          <ListActivities
            title="Lista de Actividades"
            reactTableData={listActivities}
            ReactTableActions={ListActivitiesActions}
            idFactibilidad={feasibility.id_factibilidad}
            actividades={actividades}
          />
        </Col>
      </Row>
    );
  }

  const assignNumber = () => {
    let activityList = [];
    for (let i = 0; i < activities.length; i++) {
      activities[i].position = i;
      activities[i].id_visita = visit.id_visita;
      activities[i].feasibility = feasibility;
      activityList.push(activities[i])
    }
    setListActivities(activities.length > 0 ? activities : []);
  }

  React.useEffect(() => {
    assignNumber();
  }, []);

  return (
    <div className={`collapse__wrapper_visit ${view.styleClass} ${className}`} dir="ltr">
      <button onClick={toggle} className="collapse__title" type="button">
        {view.icon}

        <Row>
          <Col md={5}>
            <p className="text-dark">
              <b style={{ color: '#71BFDF' }} className="h4">
                {numberVisit}
              </b>
              &nbsp;&nbsp;&nbsp;
              {title}
              &nbsp;&nbsp;&nbsp;
              <IconButton
                onClick={editVisit} className="text-success"
              >
                <FontAwesomeIcon icon={faEdit} />
              </IconButton>
              <IconButton
                onClick={deleteVisitAction} className="text-danger"
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </IconButton>
            </p>

          </Col>
          <Col md={2}>
            <b>Costo:{costVisit}</b>
          </Col>
          <Col md={2}>
            <b>Venta:{diffVisit}</b>
          </Col>
          <Col md={2}>
            <b>Patrocinador:{sponsorVisit}</b>
          </Col>

          <Col md={1}>
            <p>
              {collapse == false ? <FontAwesomeIcon icon={faPlus} className="text-dark" />
                :
                <FontAwesomeIcon icon={faMinus} className="text-dark" style={{ color: '#71BFDF' }} />
              }

            </p>
          </Col>


        </Row>

      </button>
      <Collapse
        isOpen={collapse}
        className="collapse__content"
        onEntering={onEntering}
        onEntered={onEntered}
        onExiting={onExiting}
        onExited={onExited}
      >
        <div>
          <AllActivities />
        </div>
      </Collapse>

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => okModal()}
        toggle={() => {

          if (colorAlertModal != "success") {
            setAlerShowModal(false);
            setDeleteVisit(false);
          }
          else {
            setDeleteVisit(false);
            let _url = "/clinical-studio/budget";
            if (window.location.pathname === process.env.PUBLIC_URL + '/clinical-studio/budget') {
              history.replace(process.env.PUBLIC_URL+"/");
              setTimeout(() => {
                history.replace({
                  pathname: process.env.PUBLIC_URL +_url,
                  state: feasibility
                });
              }, 0);
            } else {
              history.push({
                pathname: process.env.PUBLIC_URL +_url,
                state: feasibility
              });
            }
          }

        }
        }
      />
    </div>
  );
};

MedicalCollapseComponent.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
};

MedicalCollapseComponent.defaultProps = {
  title: '',
  className: '',
};

export default MedicalCollapseComponent;
